module.exports = __webpack_public_path__ + "static/media/growTowerGreens.c47f4180.jpg";